import Cookies from "js-cookie"

// 节流（防止重复点击）
export function throttle(fn) {
    let canRun = true // 通过闭包保存一个标记
    return function() {
    if (!canRun) return // 在函数开头判断标记是否为true，不为true则return
    canRun = false // 立即设置为false
    fn.apply(this, arguments)
    setTimeout(() => { // 将外部传入的函数的执行放在setTimeout中
        // 最后在setTimeout执行完毕后再把标记设置为true(关键)表示可以执行下一次循环了。当定时器没有执行的时候标记永远是false，在开头被return掉
        canRun = true
    }, 3000)
    }
}
  
export function getPicUrl() {
    return localStorage.getItem('picUrl')
}

export function setPicUrl(picUrl) {
    return localStorage.setItem('picUrl', picUrl)
}

export function setToken(token) {
    Cookies.set("token", token)
}

export function getToken() {
    return Cookies.get("token")
}
